<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="icon-screen-smartphone"></i> Terminais POS
        <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
          <i class="fa fa-angle-left"></i>
          Voltar
        </b-link>
      </div>
      <b-card-body>
        <div class="alert alert-danger" role="alert" v-show="hasError">{{errorMessage}}</div>
        <form @submit.prevent="validate" class="needs-validation" novalidate>
          <div class="form-row">
            <div class="col-sm-4">
              <base-input
                :disabled="isEditAction ? true : false"
                label="Serial Number"
                required
                type="text"
                placeholder="Digite o serial number"
                v-model="model.serialNumber"
                v-validate="modelValidations.serialNumber"
                data-vv-name="serialNumber"
                data-vv-as="serial number"
                maxlength="255"
                :error="getError('serialNumber')"
              />
            </div>
            <div class="col-sm-4">
              <base-input
                label="Logic Number"
                required
                type="text"
                placeholder="Digite o logic number"
                v-model="model.logicNumber"
                v-validate="modelValidations.logicNumber"
                data-vv-name="logicNumber"
                data-vv-as="logic number"
                maxlength="255"
                :error="getError('logicNumber')"
              />
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Status</label>
                <div><strong>{{currentStatus}}</strong></div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="exampleFormControlSelect1">Modelo</label>
                <select
                  :class="{'custom-select': true, 'is-invalid': errors.has('deviceModelId')}"
                  v-validate="modelValidations.deviceModelId"
                  v-model="model.modelId"
                  data-vv-name="deviceModelId"
                  data-vv-as="modelo"
                >
                  <option
                    v-for="(s, index) in deviceModelList"
                    :key="index"
                    :value="s.id"
                  >{{s.name}}</option>
                </select>
                <div
                  v-show="errors.has('deviceModelId')"
                  class="invalid-feedback"
                >{{ errors.first('deviceModelId') }}</div>
              </div>
            </div>
            <div class="col-sm-4">
              <template v-if="isEditAction == false || (model.contractName == null || model.contractName == '')">
                <div class="form-group">
                  <label>Contrato</label>
                  <input
                    disabled
                    type="text"
                    class="form-control-plaintext"
                    value="Sem contrato associado"
                  />
                </div>
              </template>
              <template v-else>
                <div class="form-group">
                  <label>Contrato</label>
                  <input
                    disabled
                    type="text"
                    class="form-control-plaintext"
                    :value="model.contractName"
                  />
                </div>
              </template>
            </div>
            <div class="col-sm-4">
              <template v-if="isEditAction == false || (model.sellerName == null || model.sellerName == '')">
                <div class="form-group">
                  <label>Empresa</label>
                  <input
                    disabled
                    type="text"
                    class="form-control-plaintext"
                    value="Sem empresa associada"
                  />
                </div>
              </template>
              <template v-else>
                <div class="form-group">
                  <label>Empresa</label>
                  <input
                    disabled
                    type="text"
                    class="form-control-plaintext"
                    :value="model.sellerName"
                  />
                </div>
              </template>              
            </div>
          </div>
          <div class="form-row" v-if="isEditAction">
            <div class="col-sm-4">
              <div class="form-group">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="isDanified"
                    id="chkDanified"
                    :disabled="model.status == 'DANIFIED'"
                  />
                  <label class="custom-control-label" for="chkDanified">Danificado?</label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" v-if="isEditAction && isDanified && model.status != 'DANIFIED'">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Observação</label>
                <textarea class="form-control" v-model="danifiedInfo" id="textarea-input" name="textarea-input" rows="9" placeholder=""></textarea>
              </div>
            </div>
          </div>
          <template v-if="isEditAction">
            <h4 class="mt-5">Historico</h4>
            <b-table
              :items="result.data"
              :fields="fields"
              :striped="true"
              responsive
              :busy="tableLoading"   
            >
              <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
              <template slot="updatedAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>                      
            </b-table>
            <nav>
                <b-pagination
                :total-rows="result.rowCount"
                :per-page.sync="result.pageSize"
                v-model="currentPage"
                prev-text="Voltar"
                next-text="Próximo"
                @change="pageIndexChanged"
                first-text="Primeiro"
                last-text="Último"
                />
            </nav>
          </template>
          <hr class="mt-5" />
          <template v-if="model.status == 'DANIFIED'">
              <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary">
                  <i class="fa fa-angle-left"></i>
                  Voltar
              </b-link>
          </template>
          <template v-else>                        
              <button type="submit" class="btn btn-primary">Salvar</button>
          </template>          
        </form>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import domainService from "../../../services/Devices/deviceService";
import deviceModelService from "../../../services/Devices/deviceModelService";
import cTable from '../../../components/base/Table.vue'
import editPage from "../../../mixins/editPage";
import _ from "lodash";
import deviceService from '../../../services/Devices/deviceService';
import moment from 'moment';
export default {
  props: {
    id: String
  },
  components: {
    cTable
  },
  mixins: [editPage],
  data() {
    return {
      actionUri: "/partners/devices",
      deviceModelList: [],
      isDanified: false,
      model: {
        serialNumber: "",
        logicNumber: "",
        status: 'OPEN',
        modelId: null,
        sellerName: '',
        contractName: '',
        sellerId: ''     
      },
      modelValidations: {
        serialNumber: {
          required: true,
          max: 255
        },
        logicNumber: {
          required: true,
          max: 255
        },
        status: {
          required: true
        },
        deviceModelId: {
          required: true
        }
      },
      tableLoading: false,
      currentPage: 1,
      result: this.getEmptyResult(),
      fields: [
        {key: 'updatedAt', label: 'Data', sortable: false},
        {key: 'status', label: 'Status', sortable: false},
        {key: 'sellerName', label: 'Seller', sortable: false},
        {key: 'description', label: 'Descrição', sortable: false},
        {key: 'userName', label: 'Usuario', sortable: false},
      ],
      danifiedInfo: ''
    };
  },
  computed: {
    action() {
      return this.$route.name;
    },
    isEditAction() {
      return this.action == 'edit_device'
    },
    currentStatus() { 
      return deviceService.getStatusName(this.model.status);      
    }
  },
  watch:{
    'isDanified': function(newValue) {
      // if(newValue == false) {
      //   this.model.status = this.model.sellerId == '' ? 'OPEN' : 'ATTACHED'
      // }
    }
  },
  created() {
    this.fetchData();
    this.fetchHistoryData(1);
  },
  methods: {
    bindStatusName(value) {
        return domainService.getStatusName(value);
    },
    formatDateTimeFields(value) {
      return value == null || value == '' || value == '0001-01-01T00:00:00' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
    },
    fetchHistoryData(page) {
      if (this.action != "edit_device") return;
      const self = this;
      self.tableLoading = true;
      domainService.findAllStatusHistories({
          serialNumber: this.id,
          sellerId: null,
          page: page,
          pageSize: 0            
        })
      .then(
        (response) => {
            if(response.status == 204) {
              self.result = self.getEmptyResult();                        
            }
            else {
              self.result = response.data;                        
            }
            self.tableLoading = false;
        },
        (error) => {
            self.tableLoading = false;
        }
      );
    },
    pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchHistoryData(page);
    },
    getEmptyResult() {
      return {
        pageIndex: 1,
        pageCount: 0,
        rowCount: 0,
        pageSize: 0,
        data:[]
      }
    },
    fetchData() {
      const self = this;
      this.showLoading();
      deviceModelService.all().then(
        response => {
          self.deviceModelList = response.status == 204 ? [] : response.data;
          self.deviceModelList.unshift({
            id: null,
            name: "Selecione um modelo"
          });
          self.hideLoading();
        },
        error => {
          self.showError(error.response.data.result.errors[0].description);
          self.hideLoading();
        }
      );

      if (this.action == "edit_device") {
        self.showLoading();
        domainService.find(this.id).then(
          response => {
            self.model = response.data;
            self.isDanified = self.model.status == 'DANIFIED';
            self.hideLoading();
          },
          error => {
            self.showError(error.response.data.result.errors[0].description);
            self.hideLoading();
          }
        );
      }
    },
    validate() {
      this.showLoading();
      const self = this;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if(this.isEditAction) {
            self.model.id = self.id;
            if (self.isDanified) {
              domainService.danify(self.id, self.danifiedInfo).then(
                () => {
                  self.hideLoading();
                  self.$router.push({ path: self.actionUri });
                },
                error => {
                  self.showError(
                    error.response.data.result.errors[0].description
                  );
                  self.hideLoading();
                }
              );
            }
            domainService.update(self.model).then(
              () => {
                self.hideLoading();
                self.$router.push({ path: self.actionUri });
              },
              error => {
                self.showError(
                  error.response.data.result.errors[0].description
                );
                self.hideLoading();
              }
            );
          }
          else {
            self.model.status = 'OPEN'; //livre
            domainService.create(self.model).then(
              () => {
                self.hideLoading();
                self.$router.push({ path: self.actionUri });
              },
              error => {
                self.showError(
                  error.response.data.result.errors[0].description
                );
                self.hideLoading();
              }
            );
          }          
        } else {
          self.hideLoading();
        }
      });
    }
  }
};
</script>
